import TransactionDetailModal from './TransactionDetailModal'

export default TransactionDetailModal
